import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../FontKeys';
import Creature from '../game/Creature';
import Ghost from '../game/Ghost';
import Keyboard from '../game/Keyboard';
import NavBar from '../game/NavBar';
import Popup from '../game/Popup';
import Sky from '../game/Sky';
import gameData from '../gameData';

/**
 * This is your first scene.
 */
export default class Game extends Phaser.Scene
{
    static get KEY() { return 'Game'; }

    create()
    {
        this._lastWordIndex = 0;
        Phaser.Utils.Array.Shuffle(gameData.WORD_BANK);
        gameData.GAME_STATE = "game";

        this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

        this.createBG();
    };

    createBG()
    {
        //create the needed assets for bg and intro
        this.bg = gameData.DESKTOP ? ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bground", this) : ABCyaPhaser.Images.addImage(this.mid.x, this.mid.y, "bgroundM", this);

        this.sky = new Sky(this);

        this.houseB = ABCyaPhaser.Images.addImage(0, 0, "houseBack", this);
        this.houseB.name = "houseBack";
        this.houseF = ABCyaPhaser.Images.addImage(0, 0, "houseFront", this);
        this.houseF.name = "houseFront";

        const newY = gameData.DESKTOP ? this.mid.y*2 - this.houseB.height/2 - 120 : this.mid.y*2 - this.houseB.height/2 - 300;
        this.houseB.setPosition(this.mid.x*2 - this.houseB.width/2 - 30, newY);
        this.houseF.setPosition(this.houseB.x + 35, this.houseB.y + 100);

        this.createNav();
        this.createGhost();
        this.createKeyboard();
        this.sky.skyIntro();
    };

    createGhost(addDelay = false){
        if(!gameData.GAME_DONE){
            if(gameData.GHOST_ARR.length < 4){
                if(addDelay){
                    const randWait = Phaser.Math.Between(100, 3000);
                    this.createTween = this.time.delayedCall(randWait, ()=>{
                        const randGhost = Phaser.Math.Between(1,4);
                        const gWord = this.selectWord();
                        const ghost = new Ghost(this, randGhost, this);
                        ghost.setWord(gWord, true);

                        gameData.GHOST_ARR.push(ghost);  
                    });
                } else {
                    const randGhost = Phaser.Math.Between(1,4);
                    const gWord = this.selectWord();
                    const ghost = new Ghost(this, randGhost, this);
                    ghost.setWord(gWord, true);

                    gameData.GHOST_ARR.push(ghost);  
                };
            };
        };
    };

    createKeyboard(){
        this.keyBoard = new Keyboard(this, this.mid.x, this.mid.y*2);
    };

    createNav(){
        //create the navigation and title
        this.navBar = new NavBar(this);
    };

    selectWord(){
        const randomWord = gameData.WORD_BANK[this._lastWordIndex];
        this._lastWordIndex = (this._lastWordIndex + 1) % gameData.WORD_BANK.length;

        if(gameData.WORDS_SELECTED.some(word => word.startsWith(randomWord.charAt(0)))) {
          // the random word starts the same letter as a word that is already being shown... skip it
          return this.selectWord();
        }

        gameData.WORDS_SELECTED.push(randomWord);

        return randomWord;
    };

    loseLife(){
        gameData.LIVES--;
        this.navBar.setLives();
 
        if(gameData.LIVES <= 0){
            // console.log("GAME OVER");
            gameData.GAME_DONE = true;
            this.showPopup();
        }
    };
 
    showPopup(){
        this.popup = new Popup(this);
            
        gameData.GAME_PAUSED = true;

        this.tweens.pauseAll();
 
        this.navBar.disableNav();
        
        if(this.keyBoard) this.keyBoard.isActive = false;
    };
 
    destroyPopup(){
        this.popup.destroyPopup();
        this.popup = null;

        gameData.GAME_PAUSED = false;

        this.tweens.resumeAll();
 
        this.navBar.enableNav();
 
        if(this.keyBoard) this.keyBoard.isActive = true;
    };

    destroyGame(){
        // console.log("destroying Game");

        gameData.SCORE = 0;
        gameData.LIVES = 6;
        gameData.SPEED = 10000;
        gameData.GHOST_ARR = [];
        gameData.WORDS_SELECTED = [];
        gameData.WORDS_MADE = 0;
        gameData.WORD = "";
        gameData.GAME_PAUSED = false;
        gameData.GAME_DONE = false;

        this.sound.stopAll();
        this.tweens.killAll();

        this.popup.destroyPopup();
        this.sky.destroySky();
        this.navBar.removeAll();
        this.navBar.destroy();

        this.bg.destroy();
        this.houseB.destroy();
        this.houseF.destroy();

        this.scene.start("Intro");
    };
}